import { $ } from '@/libs/jquery/index'

export class LeadsPopularHelper {
  public base: JQuery | null = null

  private readonly selectors: ISelectors = {
    base: '[data-selector="leadsPopular"]',
    item: '[data-selector="leadsPopularItem"]',
  }

  constructor() {
    this.base = $(this.selectors.base)

    if (this.base.length) {
      this.init()
    }
  }

  public init(): void {
    // скрыть блок Популярные предложения, если нет продуктов
    if (this.base.find(this.selectors.item).length === 0) {
      this.base.addClass('hidden')
    }
  }

}
